export enum TelemetrySdkEventSource {
    Client = "Client"
}
